<div class="search">
    <search-input-basic
        [debounceTimeInner]="debounceTime"
        [textInner]="text"
        [textPlaceholderInner]="textPlaceholder"
        (textChangeInner)="textChangeIn($event)"
    ></search-input-basic>
</div>
